<template>
  <div class="">
    <div class="px-6 pt-6 pb-6 mb-6 bg-white">
      <div class="w-full">
        <div class="w-full mb-6 border-b border-gray-300">
          <h3 class="mb-2">Delivery Options</h3>
        </div>
        <div class="mb-6">
          <label class="block mb-2">Delivery Method</label>
          <el-select :value-key="'delivery_method'" v-model="delivery_method_id" placeholder="Select">
            <el-option
              v-for="item in deliveryMethods"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="mb-6">
          <label class="block mb-2">Delivery Option</label>
          <el-select multiple v-model="delivery_option_id" placeholder="Select">
            <el-option
              v-for="item in deliveryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="mb-6" v-if="delivery_option_id.includes(HOME_DELIVERY_OPTION_ID)">
          <label class="block mb-2">Home Delivery Option</label>
          <el-select :value-key="'home_options'" v-model="home_delivery_option_id" placeholder="Select">
            <el-option
              v-for="item in homeDeliveryOption"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="px-6 pt-6 pb-6 mb-6 bg-white">
      <div class="w-full">
        <div class="w-full mb-6 border-b border-gray-300">
          <h3 class="mb-2">Payment Options</h3>
        </div>
        <div class="mb-6">
          <label class="block mb-2">Payment Method</label>
          <el-select :value-key="'payment_method'" v-model="payment_method_id" placeholder="Select">
            <el-option
              v-for="item in paymentMethods"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="payment_method_id === 1">
          <div class="mb-6">
            <label class="block mb-2">Paystack Secret key</label>
            <input v-model="paystack_secret_key" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Paystack Merchant ID</label>
            <input v-model="paystack_merchant_id" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
        </div>
        <div v-if="payment_method_id === 2">
          <div class="mb-6">
            <label class="block mb-2">Fluterwave Secret key</label>
            <input v-model="flw_secret_key" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Fluterwave Merchant ID</label>
            <input v-model="flw_merchant_id" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
        </div>
      </div>
    </div>
    <div class="px-6 pt-6 pb-6 mb-6 bg-white">
      <div class="w-full">
        <div class="w-full mb-6 border-b border-gray-300">
          <h3 class="mb-2">Social Authentication</h3>
        </div>
        <div class="mb-6">
          <label class="block mb-2">Social Auth</label>
          <el-select :value-key="'social_auth'" multiple v-model="social_auth_ids" placeholder="Select">
            <el-option
              v-for="item in socialAuth"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="social_auth_ids.includes(1)">
          <div class="mb-6">
            <label class="block mb-2">Facebook Client ID</label>
            <input v-model="fb_client_id" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Facebook Client Secret</label>
            <input v-model="fb_client_secret" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Facebook Redirect URI</label>
            <input v-model="fb_redirect_uri" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
        </div>
        <div v-if="social_auth_ids.includes(2)">
          <div class="mb-6">
            <label class="block mb-2">Google Client ID</label>
            <input v-model="gg_client_id" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Google Client Secret</label>
            <input v-model="gg_client_secret" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Google Redirect URI</label>
            <input v-model="gg_redirect_uri" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
        </div>
        <div v-if="social_auth_ids.includes(3)">
          <div class="mb-6">
            <label class="block mb-2">Twitter Client ID</label>
            <input v-model="tw_client_id" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Twitter Client Secret</label>
            <input v-model="tw_client_secret" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
          <div class="mb-6">
            <label class="block mb-2">Twitter Redirect URI</label>
            <input v-model="tw_redirect_uri" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
          </div>
        </div>
      </div>
    </div>
    <div class="px-6 pt-6 pb-6 mb-6 bg-white">
      <div class="w-full">
        <div class="w-full mb-6 border-b border-gray-300">
          <h3 class="mb-2">Other Configs</h3>
        </div>
        <div class="mb-6">
          <label class="block mb-2">Vat %</label>
          <input v-model="vat_rate" class="md:w-full lg:w-1/2 block mt-2 h-10 pl-4 w-full border border-gray-500 hover:border-blue-500" type="text">
        </div>
      </div>
    </div>
    <el-button @click="update()" type="primary">
      <Spinner v-if="loading" size="small" line-fg-color="#00aba1" line-bg-color="#ccc" style="display: inline-block;"/>
      <span v-if="!loading">Update</span>
    </el-button>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import Config from '../../helper/config';

export default {
  name: 'Config',
  data() {
    return {
      loading: false,
      HOME_DELIVERY_OPTION_ID: 1,
    };
  },
  components: {
    Spinner,
  },
  computed: {
    ...Config,
    deliveryMethods() {
      return this.$store.state.SettingsModule.Config.delivery_method.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    deliveryOptions() {
      return this.$store.state.SettingsModule.Config.delivery_option.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    paymentMethods() {
      return this.$store.state.SettingsModule.Config.payment_method.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    socialAuth() {
      return this.$store.state.SettingsModule.Config.social_auth.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    homeDeliveryOption() {
      return this.$store.state.SettingsModule.Config.home_delivery_options.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
  },
  methods: {
    async update() {
      try {
        this.loading = true;
        await this.$store.dispatch('SettingsModule/Config/saveMerchantConfig');
        await this.$store.dispatch('SettingsModule/Config/saveMerchantDeliveryOptions');
        this.$notify.success({
          title: 'Success',
          message: 'Update was successful',
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: 'An error occurred, please try again later.',
        });
      }
    },
  },
};
</script>

<style scoped>

</style>
